import React, { FC, useState } from "react"
import { useHistory } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { QuestionProps } from '../../../typings/register';
import { RootState } from "../../../redux/store";
import { updateMemberBirthday, updateMemberNickName } from '../../../services/memberService'
import QuestionUpdateHeader from "./QuestionUpdateHeader";
import EditNickName from "../../../components/EditNickName";
import { useDispatch } from 'react-redux';
import { setUserData } from "../../../redux/member";

const UpdateNickName: FC = () => {
    const [question, setQuestion] = useState<QuestionProps>();
    const member = useSelector((state: RootState) => state.member);
    let history = useHistory();
    const dispatch = useDispatch();


    const onSave = async (value: string) => {
        await updateMemberNickName(member.memberCode, value);
        member.nickName = value;
        dispatch(setUserData(member));
        history.goBack();
    };


    return (
        <>
            <QuestionUpdateHeader />
            <EditNickName
                buttonText={"שמור"}
                subtitle={"הכינוי שלך באפליקציה"}
                title={"איך לקרוא לך כאן"}
                value={member.nickName}
                onSave={onSave}
            />
        </>
    )
}

export default UpdateNickName


